export default "__VITE_ASSET__f56580dd__"